import dashboardWidget from './dashboardWidget'

export default class dashboardWidgetCounts extends dashboardWidget {

}
